import React, { useState } from "react";
import MarketingHeader from "@/components/MarketingHeader";
import { LEARNING_CATEGORIES } from "@/lib/learningContent";

export default function Learning() {
  const [active, setActive] = useState(null);

  return (
    <div className="mkt-page" data-testid="page-learning">
      <MarketingHeader />

      <section className="mkt-hero">
        <div className="mkt-eyebrow">◢ LEARNING CENTER</div>
        <h1 className="mkt-h1">Tutorials and how-tos for getting the most out of GovCo.AI</h1>
        <p className="mkt-sub">
          Short, practical guides organized by what you're trying to do — from your first sync to your
          first submission.
        </p>
      </section>

      <section className="mkt-body">
        <div className="learn-grid">
          {LEARNING_CATEGORIES.map((cat) => (
            <div className="learn-cat" key={cat.title}>
              <h2 className="mkt-h3">{cat.title}</h2>
              <div className="learn-articles">
                {cat.articles.map((a) => (
                  <button
                    type="button"
                    className="learn-article learn-article-playable"
                    key={a.title}
                    data-testid={`learn-video-${a.video.replace(".mp4", "")}`}
                    onClick={() => setActive(a)}
                  >
                    <span className="learn-article-title">{a.title}</span>
                    <span className="learn-article-meta">
                      <span>{a.read}</span>
                      <span className="pill-watch">▶ Watch</span>
                    </span>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {active && (
        <div
          className="learn-video-backdrop"
          data-testid="learn-video-modal"
          onClick={() => setActive(null)}
        >
          <div className="learn-video-card" onClick={(e) => e.stopPropagation()}>
            <div className="learn-video-card-head">
              <span className="learn-video-card-title">{active.title}</span>
              <button
                type="button"
                className="learn-video-close"
                data-testid="learn-video-close"
                onClick={() => setActive(null)}
                aria-label="Close video"
              >
                ✕
              </button>
            </div>
            <video
              key={active.video}
              src={`/videos/tutorials/${active.video}`}
              controls
              autoPlay
              className="learn-video-player"
            />
          </div>
        </div>
      )}
    </div>
  );
}
